<template>
  <div id="app" style="height: 100%">
    <router-view />
    <plugin-com
      v-show="false"
      ref="de-theme"
      component-name="ThemeSetting"
    />
  </div>
</template>

<script>
import PluginCom from '@/views/system/plugin/PluginCom'

export default {
  name: 'App',
  components: { PluginCom },
  beforeCreate() {

  }
}

</script>
<style>
body{
  height: 100%;
  line-height: 1.4 !important;
}
</style>
